import React, {useContext, useState, useEffect} from 'react';
import { useNavigate, useParams, useLocation, useSearchParams  } from 'react-router-dom'; 
import * as Yup from 'yup';
import axios from 'axios';
import {BASE_URL} from '../config'
import swal from 'sweetalert'
import FileUploadProgress from '../Components/FileUploadProgress'
import {AuthContext} from '../context/AuthContext'
import utilities from '../utilities'
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'

const UploadDocument = (props) => {

    let { registrationID, document} = useParams();
    const navigate = useNavigate();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [rememainingTime, setRemainingTime] = useState(0);
    const[documentPath, setDocumentPath] = useState('');
    const {userInfo} = useContext(AuthContext);

    const validFileExtensions = { image: ['jpg', 'png', 'jpeg'] };
    
    var rID = utilities.decryptData(registrationID);
    var doc = utilities.decryptData(document);

    const {data} = useApi( {url: '/Registration/GetAppliationByID?RegistrationID=' + rID, method: 'get' });



    function isValidFileType(fileName, fileType) {
      return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
    }
    
    function getAllowedExt(type) {
      return validFileExtensions[type].map((e) => `.${e}`).toString()
    } 
    
    let allowedExts = getAllowedExt('image');
    const MAX_FILE_SIZE = 102400;

    const myUploadProgress = (myFileId, startAt) => (progressEvent) => {

        const { loaded, total } = progressEvent;
        const percentage = (loaded * 100) / total;
        const timeElapsed = Date.now() - startAt;
        const uploadSpeed = loaded / timeElapsed;
        const duration = (total - loaded) / uploadSpeed;

        if (myFileId == "document")
        {
            setUploadProgress(+percentage.toFixed(2));
            setRemainingTime(duration);              
        }

      }


      const sleep = async (milliseconds) => {
        await new Promise(resolve => {
            return setTimeout(resolve, milliseconds)
        });
      };
    

  const handleFileUpload = (event) => {
    let startAt = Date.now();
    const file = event.target.files[0];
    var size = file.size;
    //if (size > MAX_FILE_SIZE)
    //{
    //  alert('only allowed 100 kb file size');
    //  return;
    //}
    const fd = new FormData();
    fd.append("file", file);
    axios
      .post(BASE_URL + "/Registration/ClearScrutinyObjection?RegistrationID=" + rID + "&Document=" + doc + "&ScrutinyStatus=" + data.scrutinyStatus + "&isPendingCNIC=" + data.isPendingCorrectionCNIC + "&isPendingMatric=" + data.isPendingCorrectionMatric + "&isPendingVerification=" + data.isPendingCorrectionVerification, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.jwt}`
        },
        onUploadProgress : myUploadProgress(event.target.name, startAt)

      })
      .then(async(response) => {
        setDocumentPath(response.data);
        await sleep(5000);
        navigate('/registration/applications/rejected');
      })
      .catch((error) => {
        console.log(error);
      });
  };



  useEffect(() => {

    
}, []);




  return (
    
    <>
    {!data ? (<Loader />) : (
        <div className="">

              <div className='col-12'>
                  <p className="text-uppercase fs-5 fw-bold">Upload {doc} Document</p>
              </div>

              {doc === 'cnic'? (
                <p className='text-danger'>{data.cnicObjection}</p>
                ):(doc === 'matric' ? (
                    <p className='text-danger'>{data.matricObjection}</p>
                            ) : (<p className='text-danger'>{data.verificationObjection}</p>)
                )
              }

              <hr></hr>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">Candidate Name</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.studentName}</span>
                </div>
            </div>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">Father Name</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.fatherName}</span>
                </div>
            </div>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">CNIC</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.cnic}</span>
                </div>
            </div>


              <div className='col-12 mt-4 mb-3'>
                <label>Upload <span className='text-uppercase'>{doc}</span> </label>

                <input type="file" class="form-control" name="document" accept={allowedExts} onChange={(e) => {handleFileUpload(e)}}/>
                <FileUploadProgress progress={uploadProgress} remaining={rememainingTime} />
                {documentPath ? (<>
                  <div><img src={documentPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                  <div><a href={documentPath} target='_blank'> View Large Document </a></div></>
                ) : (doc === 'cnic'? (
                        <>
                            <div><img src={data.cnicPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                            <div><a href={data.cnicPath} target='_blank'> View Large Document </a></div>
                        </>): (
                            doc === 'matric' ? (
                                <>
                                    <div><img src={data.matricDMCPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                                    <div><a href={data.matricDMCPath} target='_blank'> View Large Document </a></div>                                
                                </>
                            ) : (!data.matricVerificationPath ? (<>
                                <div>
                                  <span>Matric Verification was not uploaded</span> 
                                </div>
                                </>
                              ) : ( 
                              <>
                                <div><img src={data.matricVerificationPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                                <div><a href={data.matricVerificationPath} target='_blank'> View Large Document </a></div>
                              </>
                              )                            
                            )
                        )
                    
                )
                 }                                
              </div> 




       </div>  
    )}
    </>
  );

};

export default UploadDocument;
